import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@/styles/globals.css";
import { bootstrap } from "@/app/bootstrap";

// **`@/app/root` 必须是动态 import，不能是静态的**（2026-08-28,admin.oms 全白事故）。
// ESM 会在 main.tsx 的第一条语句之前求值它的全部静态依赖，而 `lib/api/gen/client.gen.ts`
// 在模块顶层就 `createClientConfig()` → 读 `env.EDGE_BASE_URL`。静态引 Root 时，下面这个
// `await bootstrap()` 永远排在那次读之后 —— 顺序不是被写错了，是被 ESM 规则判定为不可能。
// 症状还格外难查:throw 发生在 import 求值期,main() 都没进,所以连下面那个 catch 的
// 「bootstrap failed」都印不出来,页面是纯白的。
async function main() {
  await bootstrap();
  const { Root } = await import("@/app/root");

  const container = document.getElementById("root");
  if (!container) throw new Error("Root container not found");

  createRoot(container).render(
    <StrictMode>
      <Root />
    </StrictMode>,
  );
}

// 启动失败必须**看得见**（蓝图 ADR-0102 的 fail-stop：宁可停在一条说清原因的错误上,
// 也不要带着 undefined 的地址跑起来）。只 console.error 等于把 fail-stop 退化成静默白屏 ——
// 用户看到的和「页面还在加载」一模一样,而运维看到的是 200。写进 #root 是本工作区 17 个
// SPA 里 15 个的既有做法,这里是补齐,不是发明。
main().catch((err: unknown) => {
  const container = document.getElementById("root");
  const message = err instanceof Error ? err.message : String(err);
  console.error("[main] bootstrap failed", err);
  if (container) {
    container.textContent = `应用启动失败：${message}`;
  }
});
